import { StyledCol, StyledTitle } from '@/shared/styles';
import {
  StyledAccordionContent,
  StyledExampleContainer,
  StyledSelectorContainer,
} from '../AccessibilityIssues.styles';
import { ClipboardSyntaxHighlighter } from '@/Views/AfterLogin/Main/Docs/ClipboardSyntaxHighlighter/ClipboardSyntaxHighlighter';
import { StyledAccordionItemSeparator } from '@/shared/components/Accordion/Accordion.styles';
import { IssueDetailsProps } from './FilteredIssues.consts';
import { useTranslation } from 'react-i18next';

export const IssueDetails: React.FC<IssueDetailsProps> = ({
  item,
  index,
  isLast,
}: IssueDetailsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledCol $gap={12}>
        <StyledTitle level={4} className="u1st-sr-only">
          {`${t('free_tools.accessibility_checker.filtered_issues.occurence')} ${index + 1}`}:
        </StyledTitle>
        <StyledExampleContainer>
          <StyledAccordionContent>
            {t('free_tools.accessibility_checker.filtered_issues.html_element')}
          </StyledAccordionContent>
          <ClipboardSyntaxHighlighter content={item.snippet} />
        </StyledExampleContainer>
        <StyledSelectorContainer>
          <StyledAccordionContent>
            {t('free_tools.accessibility_checker.filtered_issues.element_selector')}
          </StyledAccordionContent>
          <ClipboardSyntaxHighlighter content={item.selector} />
        </StyledSelectorContainer>
      </StyledCol>
      {!isLast && <StyledAccordionItemSeparator className="examples-separator" />}
    </>
  );
};
